module.exports = __webpack_public_path__ + "static/media/icn-shipped.716ed8b2.svg";